export const TEAM_NAME = 'jsm-nebula';
export const TOPICS_PAGE_SIZE = 10;
export const PACKAGE_NAME = '@atlassian/jira-servicedesk-knowledge-performance';
